import SixDigitsCodeForm from './six-digits-code-form';

export * from './six-digits-code-form';
export default SixDigitsCodeForm;